import * as React from 'react'
import type { SVGProps } from 'react'
const SvgBetaRounded = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="currentColor"
        d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10s4.477 10 10 10 10-4.477 10-10"
      />
      <mask
        id="b"
        width={12}
        height={12}
        x={4}
        y={4}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="currentColor" d="M16 4H4v12h12z" />
      </mask>
      <g mask="url(#b)">
        <path
          fill="#4855DC"
          stroke="#4855DC"
          strokeWidth={0.5}
          d="M11.77 9.164a2.22 2.22 0 0 0 .855-1.789c0-1.324-1.08-2.25-2.625-2.25A2.487 2.487 0 0 0 7.375 7.75v7.875h.75V13.42a3.06 3.06 0 0 0 2.25.93 2.77 2.77 0 0 0 2.869-2.854 2.48 2.48 0 0 0-1.474-2.332ZM10.375 13.6a2.13 2.13 0 0 1-2.246-2.006c-.004-.03-.004-.064-.004-.094V7.75A1.758 1.758 0 0 1 10 5.875c1.14 0 1.875.589 1.875 1.5a1.45 1.45 0 0 1-1.403 1.5h-.097v.75c1.286 0 2.119.735 2.119 1.875a2.023 2.023 0 0 1-2.12 2.1Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgBetaRounded
